<template>
  <div class="ui-pannel">
    <p class="title">{{$t("user.complete2")}}</p>
    <div class="content">
      <el-table :data="tableData" style="width: 100%">
        <!-- 序号 -->
        <el-table-column type="index" width="70" label="No."></el-table-column>
        <!-- 课程 -->
        <el-table-column label="Course" property="courseName"></el-table-column>
        <!-- 日期 -->
        <el-table-column label="Date" :formatter="getDate" width="100"></el-table-column>
        <!-- 开始时间 -->
        <el-table-column label="Start" :formatter="getStartTime" width="100" property="beginTime"></el-table-column>
        <!-- 结束时间 -->
        <el-table-column label="End" :formatter="getendTime" property="endTime"></el-table-column>
        <el-table-column :label="$t('common.lessons')" property="courseCount"></el-table-column>
        <!-- 学生 -->
        <el-table-column label="Student" property="userName">
          <template slot-scope="scope">
            <div style="word-wrap:break-word;">{{scope.row.userName}}</div>
          </template>
        </el-table-column>
        <!-- 状态 -->
        <el-table-column label="Status" property="stateName"></el-table-column>
      </el-table>
      <el-pagination class="ui-pagination" @current-change="changePage" background layout="total, prev, pager, next" :total="info.totalCount"></el-pagination>
    </div>
  </div>
</template>
<script>
import {getMyTeachingCourseList} from '@/service/teacherApi.js'
import moment from 'moment'
export default {
  data(){
    return {
      tableData: [{
        courseName: 'A Level',
        subject: 'English',
        date: '2018-01-01 (周一)',
        beginTime: '19:00',
        endTime: '20:00',
        courseDuration: '1' + this.$t("common.lessons"),
        studentName: 'jack',
        state: '已完成'
      }],
      info: {
        pageSize: 10,
        pageNO: 1,
        state: 2,
        totalCount: 0,
      }
    }
  },
  created(){
    this.getMyTeachingCourseList()
  },
  methods: {
    async getMyTeachingCourseList(){
      let res = await getMyTeachingCourseList(this.info)
      if(res.data.status === 1){
        res.data.data=res.data.data.sort((a,b)=>{return a.beginTime<b.beginTime?1:-1});
        this.tableData = res.data.data
        this.info.totalCount = res.data.totalCount
      }
    },
    getDate(row){
      return moment(row.beginTime * 1000).format('DD/MM/YYYY')
    },
    getStartTime(row){
      return moment(row.beginTime * 1000).format('HH:mm')
    },
    getendTime(row){
      return moment(row.endTime * 1000).format('HH:mm')
    },
    changePage(val){
      this.info.pageNO = val
      this.getMyTeachingCourseList()
    }
  }
}
</script>
<style lang="scss" scoped>
.content{padding: 50px;}
.ui-pannel{min-height: 100%;}
</style>